import { EventPayloadType } from "@package/ui-gql/index-analytics";
import {
  PostIframe,
  PostStandard,
  PostVideoUrl,
  type PostProps,
} from "@package/ui-wall-posts";
import { useEffect } from "react";
import { useWallAnalytics } from "../../context/context-analytics/context-analytics";

const tiles = {
  "60942b68093c366c54a26817": PostIframe,
  "60942b68093c366c54a26813": PostStandard,
  "633b4127d2d54efbf1d1d41e": PostVideoUrl,
};

export function Post({ post, asset, position, screen }: PostProps) {
  const { trigger } = useWallAnalytics();
  const Tile = asset?.tileType && tiles[asset.tileType as keyof typeof tiles];

  useEffect(
    function effectOnPostShown() {
      trigger(
        EventPayloadType.PostShown,
        {
          screen: screen.index,
        },
        post?.id ?? undefined,
        screen?.layout?.id ?? undefined,
      );
    },
    [post?.id, screen.index, screen?.layout?.id, trigger],
  );

  if (Tile) {
    return (
      <Tile post={post} asset={asset} screen={screen} position={position} />
    );
  }

  return null;
}
